import { ChangeDetectorRef, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, isDevMode } from '@angular/core';
import { SharedService } from '../services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalUploadBackgroundComponent } from '../modals/modal-upload-background/modal-upload-background.component'
import { AngularFireStorage } from '@angular/fire/storage';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';
import { ModalMainComponent } from '../modals/modal-main/modal-main.component';
import { FirebaseService } from '../service/firebase.service';
import { StylingService } from '../services/styling.service';
import { ModalTextComponent } from '../modals/modal-text/modal-text.component';
import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';
import * as weatherList from '../../assets/openweather-city-fr.json'
import { TranslationPipe } from '../shared/pipes/translation.pipe';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { ListSelectDeviceComponent } from '../modals/list-select-device/list-select-device.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { GlobalService } from '../services/global.service';


interface IWakeUpManager {
  enable: boolean,
  start: string,
  end: string,
  days: Array<number>
}


@Component({
  selector: 'app-settings-global',
  templateUrl: './settings-global.component.html',
  styleUrls: ['./settings-global.component.scss']
})
export class SettingsGlobalComponent implements OnInit, OnDestroy {
  // @ViewChild('rowLayout') rowLayout: ElementRef;
  dialogRef: any;
  mediaActive: any = false;
  lotteryActive: any = false;
  wayfindingActive: boolean = false;
  citySelectControl = new UntypedFormControl();
  private cityWeatherData = weatherList as any;
  public latestUpdate;
  public days = [

  ]


  options: any[] = this.cityWeatherData.default;
  filteredOptions: Observable<string[]>;

  itemsTable: Array<number[]>;
  backgroundItems: any;
  // fix column width as defined in CSS (150px + 5px margin)
  boxWidth = 110;
  // calculated based on dynamic row width
  columnSize: number;
  customLoad: string = '';
  isDev: boolean = isDevMode();


  private selectedDeviceObserver
  // weatherList: any;
  constructor(
    public sharedService: SharedService,
    public dialog: MatDialog,
    public storage: AngularFireStorage,
    private snackBar: MatSnackBar,
    public firebaseService: FirebaseService,
    public stylingService: StylingService,
    public translation: TranslationPipe,
    public _router: Router,
    private _ref: ChangeDetectorRef,
    private _global: GlobalService
  ) {
  }

  ngOnInit() {

    this.setUpDaysArray();
    this.initSettings();
    console.log(this.firebaseService.user)

    /* UPDATE BACKGROUNDS ARRAY ON DEVICE CHANGE */
    this.selectedDeviceObserver = this.sharedService.observerSelectedDevice.subscribe(d => {
      this.backgroundItems = this.sharedService.configForm.listBackgrounds
      this.initTable();
      this._ref.detectChanges();
      this.sharedService.setMetadateFromImage();
    })
  }

  ngOnDestroy() {
    if (this.selectedDeviceObserver)
      this.selectedDeviceObserver.unsubscribe();
  }

  setUpDaysArray() {
    let daysName = this.sharedService.getWeekDays(this._global.selectedLang)

    daysName.forEach((item: string, index: number) => {

      if ((index + 1) != 7)
        this.days.push({ name: item, value: (index + 1) })
      else
        this.days.push({ name: item, value: 0 })

    })
  }

  initSettings() {
    this.backgroundItems = this.sharedService.configForm.listBackgrounds
    //  console.log("CONFIG FORM", this.sharedService.configForm)


    if (!this.sharedService.configForm.homeBackgroundType) {
      this.sharedService.configForm.homeBackgroundType = 'full'
    }

    if (this.sharedService.configForm.homeBackgroundType != 'full' && !this.sharedService.configForm.listBackgroundDisplayConfig) {

      this.sharedService.configForm.listBackgroundDisplayConfig = {
        "zbottom": {
          galleryEnable: false,
          timerSlideshow: 10,
          backgroundList: [],
          position: 'bottom'
        },

        "middle": {
          galleryEnable: false,
          timerSlideshow: 10,
          backgroundList: [],
          position: 'middle'
        },
        "atop": {
          galleryEnable: false,
          timerSlideshow: 10,
          backgroundList: [],
          position: 'top'
        }
      }
    }


    this._ref.detectChanges()



    console.log("WAKEUPSETTINGS", this.sharedService.configForm.wakeUpSettings)
    if (!this.sharedService.configForm.wakeUpSettings) {
      this.sharedService.configForm.wakeUpSettings = {
        enable: false,
        start: "00:01",
        end: "23:59",
        days: []
      }

      this.days.forEach(item => {
        item.enable = false;

      })
    }
    else {
      this.days.forEach(item => {
        if (this.sharedService.configForm.wakeUpSettings.days.includes(item.value))
          item.enable = true;
      })
    }

    if (this.sharedService.selectedDevice?.data.securityPassword || (this.sharedService.selectedDevice?.data.securityPassword && this.sharedService.selectedDevice.data.securityPassword.length > 0)) {
      //  console.log("SECURITY PASSWORD", this.sharedService.selectedDevice.data.securityPassword)
      // this.dialogRef = this.dialog.open(Password);
      let _data = {
        type: 'text',
        title: this.translation.transform('adminPassword'),
        currentValue: "",
        buttonLabel: 'Valider',
        buttonColor: 'accent',
        disableClose: true
      }

      this.dialogRef = this.dialog.open(ModalMainComponent, {

        height: '350px',
        data: _data
      })

      this.dialogRef.afterClosed().subscribe(result => {
        if (!result || result.currentValue != this.sharedService.selectedDevice.data.securityPassword) {
          this.sharedService.selectedDevice = null;
          this._router.navigate(['/home'])
        }

      })

    }

    if (this.sharedService.selectedDevice != undefined && this.sharedService.selectedDevice.data.modules.media) {
      this.mediaActive = true;


      //    console.log(this.sharedService.configForm.selectedCity)
      if (this.sharedService.configForm.selectedCity)
        this.citySelectControl.setValue(this.sharedService.configForm.selectedCity.name)
    }
    if (this.sharedService.selectedDevice != undefined && this.sharedService.selectedDevice.data.modules.wayfinding) {

      this.wayfindingActive = true;
      if (this.sharedService.configForm.selectedCity)
        this.citySelectControl.setValue(this.sharedService.configForm.selectedCity.name);
    }

    if (this.sharedService.configForm.activeWeather && this.sharedService.configForm.selectedCity == undefined)
      this.sharedService.configForm.selectedCity = {};

    // console.log(this.sharedService.selectedDevice.data.modules)

    if (this.sharedService.selectedDevice.data.modules.lottery) {
      this.lotteryActive = true
    }
    this.filteredOptions = this.citySelectControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );


    if (this.sharedService.selectedDevice.data.latestUpdate?.seconds)
      this.latestUpdate = new Date(this.sharedService.selectedDevice.data.latestUpdate.seconds * 1000 + this.sharedService.selectedDevice.data.latestUpdate.nanoseconds / 1000000)
    else
      this.latestUpdate = this.sharedService.selectedDevice.data.latestUpdate;  //this.sharedService.configForm.latestUpdate

    console.log("INIT SETTINGS LATEST UPDATE", this.latestUpdate, this.sharedService.selectedDevice.data)
    //  console.log("INIT CONFIG FORM", this.sharedService.configForm)
  }

  private _filter(value): string[] {
    if (value != undefined) {
      const filterValue = value.toLowerCase();
      //  console.log("TRIGGER FILTER", filterValue)
      return this.options.filter(option => {
        let res = option.name.toLowerCase().includes(filterValue)
        return res;
      });
    }


  }

  isVisibleConfig(id) {
    switch (id) {

      case 'atop':
        if (this.sharedService.configForm.homeBackgroundType == 'full')
          return false;
        else
          return true
        break;

      case 'middle':
        if (this.sharedService.configForm.homeBackgroundType == 'full' || this.sharedService.configForm.homeBackgroundType == 'split-twothird')
          return false;
        else
          return true
        break;

      case 'zbottom':
        if (this.sharedService.configForm.homeBackgroundType == 'full')
          return false;
        else
          return true
        break;
    }
  }

  setBackgroundInCategory(type, value) {
    console.log(type, value)
    let setActive: boolean = false;

    if (this.sharedService.configForm.listBackgroundDisplayConfig[type].backgroundList.length == 0)
      setActive = true;

    //this.sharedService.configForm.listBackgroundDisplayConfig[type].backgroundList.push({ url: value, name: this.getNameFromUrl(value), active: false })
    this.sharedService.configForm.listBackgroundDisplayConfig = {
      ...this.sharedService.configForm.listBackgroundDisplayConfig, // spread creates a new object
      [type]: {
        ...this.sharedService.configForm.listBackgroundDisplayConfig[type], // spread creates a new nested object
        backgroundList: [
          ...this.sharedService.configForm.listBackgroundDisplayConfig[type].backgroundList,
          { url: value, name: this.getNameFromUrl(value), active: setActive }
        ]
      }
    };


    this.changeValue();
  }

  setSelectedCity(data) {

    //  console.log('SET SELECTED CITY', data)
    let selected = null;
    this.cityWeatherData.default.forEach(item => {

      if (item.name == data)
        selected = { name: item.name, id: item.id };
    })

    if (selected != null) {
      this.sharedService.configForm.selectedCity = selected;
      this.sharedService.submit(this.latestUpdate).then(d => { this.latestUpdate = d; this.sharedService.selectedDevice.data.latestUpdate = d })
    }

    //   console.log("CONFIG FORM AFTER CITY CHANGE", this.sharedService.configForm)

  }

  /**
  * Function to set the active background
  */
  setActiveBackground(imgUrl, pos: string = null) {

    if (pos == null) {
      this.sharedService.configForm.backgroundURL = imgUrl;
      this.sharedService.submit(this.latestUpdate).then(d => { this.latestUpdate = d; this.sharedService.selectedDevice.data.latestUpdate = d })
    }

  }


  applyToAllDeviceFromGroup() {

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('warningApplyToAll'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.firebaseService.updateGlobalSettingsOfAllGroup(this.sharedService.configForm, this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.id).then(d => {
          this.firebaseService.setLocalUser(this.firebaseService.user)
        });
      }

      else {

      }

    })
  }

  applyToSpecifiqDevice() {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('warningApplyToDevice'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.dialogRef = this.dialog.open(ListSelectDeviceComponent, {
          width: '30vw',
          height: '50vh',
          data: { title: this.translation.transform('warningApplyToDevice'), ok: 'OK', cancel: this.translation.transform('cancel'), selectedDevice: this.sharedService.selectedDevice }
        })


        this.dialogRef.afterClosed().subscribe((selectedDevice) => {
          console.log(selectedDevice)



          if (selectedDevice) {
            this.firebaseService.updateGlobalSettingsForDevice(this.sharedService.configForm, this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.id, selectedDevice).then(d => {
              this.firebaseService.setLocalUser(this.firebaseService.user)

            })
          }

        })

      }



      /*
      if (result) {
        this.firebaseService.updateGlobalSettingsForDevice(this.sharedService.configForm, this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.id).then(d => {
          this.firebaseService.setLocalUser(this.firebaseService.user)
        });
      }

      else {

      }*/

    })
  }

  /**
  * Function to remove background from list and database
  */
  removeBackground(imgUrl, pos: string = null) {

    if (pos == null) {
      this.checkIfCanRemoveBackground(imgUrl).then(res => {
        if (this.sharedService.configForm.backgroundURL != imgUrl) {
          this.sharedService.configForm.listBackgrounds.splice(this.sharedService.configForm.listBackgrounds.indexOf(imgUrl), 1)
          // this.sharedService.configForm.fullListBackgrounds.splice()
          if (this.sharedService.configForm.fullListBackgrounds)
            this.sharedService.configForm.fullListBackgrounds = this.sharedService.configForm.fullListBackgrounds.filter(v => v.url != imgUrl);

          if (!res.exist)
            this.storage.storage.refFromURL(imgUrl).delete();

          this.sharedService.submit(this.latestUpdate).then(d => { this.latestUpdate = d; this.sharedService.selectedDevice.data.latestUpdate = d });
          this.backgroundItems = this.sharedService.configForm.listBackgrounds;
          this.initTable();
          this._ref.detectChanges();
        }
        else {
          this.snackBar.open(this.translation.transform("warningCannotDeleteBackground") as string, 'OK', { duration: 5000 })
        }

      })
    }
    else if (pos) {
      this.sharedService.configForm.listBackgroundDisplayConfig[pos].backgroundList = this.sharedService.configForm.listBackgroundDisplayConfig[pos].backgroundList.filter(v => v.url != imgUrl && !v.active)
      this.changeValue();
    }

  }


  checkIfCanRemoveBackground(imgUrl) {
    let exist: boolean = false;
    return new Promise<any>((resolve, reject) => {
      this.firebaseService.getAllDevicesFromUser().then(d => {
        d.forEach((item) => {
          if (item.id != this.sharedService.selectedDevice.id) {
            if (item.data.config.backgroundURL == imgUrl) {

              exist = true;
            }
            if (item.data.config.listBackgrounds.includes(imgUrl)) {
              exist = true;
            }
          }
        })
        resolve({ exist: exist });
      })
    })
  }


  addNewBackgroundConfigElement() {
    console.log(this.sharedService.configForm);
    if (!this.sharedService.configForm.backgroundConfigList)
      this.sharedService.configForm.backgroundConfigList = [];


    if (this.sharedService.configForm.backgroundConfigList.length < 10) {
      this.sharedService.configForm.backgroundConfigList.push({
        slideshow: { active: false, time: 5 },
        active: false,
        activeBackground: '',
        listBackground: [],
        action: {
          type: 'none', config: {}
        }
      })
    }

  }

  setSubConfig(i, config) {


    console.log(config)
    if (config != null) {
      this.sharedService.configForm.backgroundConfigList[i] = config
      this.changeValue();
    }
    else {

      let deletePromise = [];

      this.sharedService.configForm.backgroundConfigList[i].listBackground.forEach((item, index, object) => {
        deletePromise.push(this.checkIfCanRemoveBackground(item).then(res => {
          if (!res.exist) {
            this.storage.storage.refFromURL(item).delete();
            object.splice(index, 1);
          }



        }))

      })

      Promise.all(deletePromise).then(d => {

        console.log("REMOVE FROM DATA")
        this.sharedService.configForm.backgroundConfigList.splice(i, 1);

        console.log(this.sharedService.configForm.backgroundConfigList)
        this.changeValue();
      })


      // 

    }


    //   console.log(i, config)
  }

  drop(event: CdkDragDrop<string[]>, id: any = null) {

    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.backgroundItems = this.itemsTable.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    //   moveItemInArray(this.sharedService.configForm.listBackgrounds, event.previousIndex, event.currentIndex);

    this.sharedService.configForm.listBackgrounds = event.container.data;

    this.changeValue();
    this.initTable();
  }

  /**
   * Open upload modal and set config after
   **/
  onUploadImage() {
    if (this.sharedService.configForm.listBackgrounds.length > this.sharedService.limitImg) {
      this.dialogRef = this.dialog.open(ModalTextComponent, {
        width: '30vw',
        height: '30vh',
        data: this.translation.transform('warningLimitBackground') + `(Maximum ${this.sharedService.limitImg})`
      })
    }
    else {
      this.dialogRef = this.dialog.open(ModalUploadBackgroundComponent, {
        width: '300px',
        height: '300px',
        data:
        {
          title: this.translation.transform('importBackground')
        }
      })

      this.dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log(result)
          this.sharedService.uploadEvent = result;
          this.sharedService.uploadFolder = 'baseConfig/backgrounds';
          this.sharedService.submit(this.latestUpdate).then(d => {

            this.latestUpdate = d;
            this.sharedService.selectedDevice.data.latestUpdate = d
            if (this.sharedService.configForm.backgroundURL == undefined || this.sharedService.configForm.backgroundURL.length <= 0) {
              this.sharedService.configForm.backgroundURL = this.sharedService.configForm.listBackgrounds[0]
              this.sharedService.submit(this.latestUpdate).then(d => {
                this.latestUpdate = d;
                this.sharedService.selectedDevice.data.latestUpdate = d
                //                this.initTable();

                //    alert("SHOW DISPLAY NEW BACKGROUNDS")
                //    this._ref.detectChanges();

                //    this.getItemsTable(this.rowLayout.nativeElement);
                // this.sharedService.setMetadateFromImage();
              });
            }
            // alert("SHOW DISPLAY NEW BACKGROUNDS")
            console.log(this.backgroundItems, this.sharedService.configForm.listBackgrounds)
            this.backgroundItems = this.sharedService.configForm.listBackgrounds;
            this.initTable();
            this._ref.detectChanges();

            //  this.getItemsTable(this.rowLayout.nativeElement);
            this.sharedService.setMetadateFromImage();

          });
        }

      });
    }

  }


  /**
  *Open modal corresponding to identifier and set config after
  *
  * @param img The image's url
  *
  * */
  getNameFromUrl(img) {
    //console.log(img, this.sharedService.urlToNameArray);
    let name;
    this.sharedService.urlToNameArray.forEach((item) => {
      if (item.url == img)
        name = item.name
    })

    if (this.sharedService.configForm.fullListBackgrounds)
      this.sharedService.configForm.fullListBackgrounds.map(v => {
        if (v.url == img)
          name = v.defaultName;
      })

    return name
  }



  changeValueDay(day) {
    console.log(day)
    if (day.enable) {
      this.sharedService.configForm.wakeUpSettings.days.push(day.value)
    }
    else {
      let tmpDays = this.sharedService.configForm.wakeUpSettings.days.filter(f => f != day.value)
      console.log(tmpDays)
      this.sharedService.configForm.wakeUpSettings.days = tmpDays;
    }

    this.changeValue();
    console.log(this.sharedService.configForm.wakeUpSettings)
  }



  updateSplitConfig(e) {
    console.log(e, this.sharedService.configForm.listBackgroundDisplayConfig)

    this.sharedService.configForm.listBackgroundDisplayConfig[e.key] = e.value

    this.changeValue();
  }

  updatePositionBackground(e) {
    console.log(e)

    this.sharedService.configForm.listBackgroundDisplayConfig[e.key].listBackground = e.list;


    console.log(this.sharedService.configForm.listBackgroundDisplay)
    this.changeValue();
  }

  changeValue() {
    this.sharedService.submit(this.latestUpdate).then(d => {

      if (this.sharedService.configForm.activeWeather && !this.sharedService.configForm.selectedCity)
        this.sharedService.configForm.selectedCity = { name: '' };

      //   console.log(this.sharedService.configForm)
      this.latestUpdate = d;
      this.sharedService.selectedDevice.data.latestUpdate = d
    });
  }


  initTable(data = null) {
    // create table rows based on input list
    // example: [1,2,3,4,5,6] => [ [1,2,3], [4,5,6] ]
    // this.backgroundItems

    this.itemsTable = this.backgroundItems.filter((_, outerIndex) => outerIndex % this.columnSize == 0) // create outter list of rows
      .map((
        _,
        rowIndex // fill each row from...
      ) =>
        this.backgroundItems.slice(
          rowIndex * this.columnSize, // ... row start and
          rowIndex * this.columnSize + this.columnSize // ...row end
        )
      );

  }

  getItemsTable(rowLayout: any): number[][] {
    //   console.log(rowLayout)
    //   console.log(rowLayout, list )
    let itemTable;
    //  console.log(rowLayout, typeof rowLayout)
    // calculate column size per row

    const { width } = rowLayout.getBoundingClientRect();
    const columnSize = Math.round(width / this.boxWidth);
    // view has been resized? => update table with new column size
    if (columnSize != this.columnSize) {
      this.columnSize = columnSize;
      this.initTable();
    }
    // console.log(this.itemsTable)
    return this.itemsTable;

  }


  /**
   *Open modal corresponding to identifier and set config after
   * 
   * @param s The modal identifier 
   *
   * */
  showModal(s: string, title = null) {


    var _data = {};
    let value;
    let resTitle
    // console.log(s, title)
    switch (s) {
      case 'welcomeText':
        _data = {
          type: 'text',
          title: this.translation.transform('changeHomeText'),
          currentValue: this.sharedService.configForm.startText,
          buttonLabel: 'Modifier',
          buttonColor: 'warn'
        }
        break;

      case 'newsBannerText':
        _data = {
          type: 'text',
          title: this.translation.transform('changeNewsBannerText'),
          currentValue: this.sharedService.configForm.newsBannerText,
          buttonLabel: 'Modifier',
          buttonColor: 'warn'
        }
        break;
      case 'sleepDelay':
        _data = {
          type: 'text',
          title: this.translation.transform('changeDelayInac'),
          currentValue: this.sharedService.configForm.inactivity,
          buttonLabel: 'Valider',
          buttonColor: 'accent'
        }
        break;

      case 'textColor':


        if (title == 'Couleur d\'affichage du texte') {
          value = this.sharedService.configForm.colorText
          resTitle = this.translation.transform('colorTextDisplay')
        }

        else if (title == 'Couleur d\'affichage de l\'arriere-plan') {
          value = this.sharedService.configForm.backgroundTextColor
          resTitle = this.translation.transform('colorBackgroundDisplay')
        }
        else if (title == "Couleur d\'affichage du texte de bienvenue") {
          value = this.sharedService.configForm.welcomeTextColor
          resTitle = this.translation.transform('colorWelcomeTextDisplay')
        }
        else if (title == "Couleur du texte de la bannière") {
          value = this.sharedService.configForm.newsBannerTextColor
          resTitle = this.translation.transform('newsBannerTextColor')
        }



        _data = {
          type: 'color',
          title: resTitle,
          currentValue: value,
          buttonLabel: 'Valider',
          buttonColor: 'accent'
        }
        break;
      case 'backgroundColor':


        if (title == `Couleur d\'arrière-plan de la bannière`) {
          value = this.sharedService.configForm.newsBannerBackgroundColor || '#000000';

          console.log("NEWS BANNER COLOR", value)
          resTitle = this.translation.transform('newsBannerBackgroundColor')

        }

        else {
          value = this.sharedService.configForm.backgroundColor || '#000000';
          resTitle = this.translation.transform('colorBackgroundDisplay')
        }

        _data = {
          type: 'color',
          title: resTitle,
          currentValue: value,
          buttonLabel: 'Valider',
          buttonColor: 'accent'
        }
        break;
      case 'buttonColor':
        _data = {
          type: 'color',
          title: this.translation.transform('colorTextDisplay'),
          currentValue: this.sharedService.configForm.colorButton,
          buttonLabel: 'Valider',
          buttonColor: 'accent'
        }
        break;
      case 'password':
        _data = {
          type: 'text',
          title: this.translation.transform('adminPassword'),
          currentValue: this.sharedService.configForm.password,
          buttonLabel: 'Valider',
          buttonColor: 'accent'
        }
        break;

      default:
        break;

    }


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '350px',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result, s)
        switch (s) {
          case 'welcomeText':
            this.sharedService.configForm.startText = result.currentValue;
            break;
          case 'newsBannerText':
            this.sharedService.configForm.newsBannerText = result.currentValue;
            break;
          case 'sleepDelay':
            if (result.currentValue < 5)
              result.currentValue = 5;
            this.sharedService.configForm.inactivity = result.currentValue
            break;

          case 'textColor':
            if (title == 'Couleur d\'affichage du texte')
              this.sharedService.configForm.colorText = result.currentValue
            else if (title == 'Couleur d\'affichage de l\'arriere-plan')
              this.sharedService.configForm.backgroundTextColor = result.currentValue
            else if (title == 'Couleur d\'affichage du texte de bienvenue')
              this.sharedService.configForm.welcomeTextColor = result.currentValue
            else if (title == 'Couleur du texte de la bannière')
              this.sharedService.configForm.newsBannerTextColor = result.currentValue;
            break;
          case 'backgroundColor':
            if (title == `Couleur d\'arrière-plan de la bannière`)
              this.sharedService.configForm.newsBannerBackgroundColor = result.currentValue;
            else
              this.sharedService.configForm.backgroundColor = result.currentValue;
            break;
          case 'buttonColor':
            this.sharedService.configForm.colorButton = result.currentValue
            break;
          case 'password':
            this.sharedService.configForm.password = result.currentValue
            break;
          default:
            break;

        }
        this.sharedService.submit(this.latestUpdate).then(d => {
          this.latestUpdate = d;
          this.sharedService.selectedDevice.data.latestUpdate = d
        });

      }

    });

  }



}


